export const Fonts = {
    main: {
        bold: 'Montserrat-Bold',
        regular: 'Montserrat-Regular',
    },
};
